var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.statusSucceed && _vm.organizationId
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              staticClass: "custom-control custom-radio custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authMode,
                    expression: "authMode",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "onlyPasswords",
                  name: "authMode",
                  value: "onlyPasswords",
                },
                domProps: { checked: _vm._q(_vm.authMode, "onlyPasswords") },
                on: {
                  change: function ($event) {
                    _vm.authMode = "onlyPasswords"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "onlyPasswords" },
                },
                [_vm._v("Passwords only")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-control custom-radio custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authMode,
                    expression: "authMode",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "mixed",
                  name: "authMode",
                  value: "mixed",
                },
                domProps: { checked: _vm._q(_vm.authMode, "mixed") },
                on: {
                  change: function ($event) {
                    _vm.authMode = "mixed"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "mixed" },
                },
                [_vm._v("Mixed (passwords and SSO)")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-control custom-radio custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authMode,
                    expression: "authMode",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "onlySso",
                  name: "authMode",
                  value: "onlySso",
                },
                domProps: { checked: _vm._q(_vm.authMode, "onlySso") },
                on: {
                  change: function ($event) {
                    _vm.authMode = "onlySso"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "onlySso" },
                },
                [_vm._v("SSO only")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.ssoSettingsVisible,
                  expression: "ssoSettingsVisible",
                },
              ],
            },
            [
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "alert alert-warning",
                  attrs: { role: "alert" },
                },
                [
                  _vm._v(
                    "\n                Only OAuth2 based SSO is supported.\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.signInUrl
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-primary",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(
                        "\n                Users can follow this link to sign in with your SSO provider:"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        { attrs: { href: _vm.signInUrl, target: "_blank" } },
                        [_vm._v(_vm._s(_vm.signInUrl))]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("OAuth2 client ID:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.clientId,
                      expression: "clientId",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.clientId },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.clientId = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("OAuth2 client secret:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.clientSecret,
                      expression: "clientSecret",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "password" },
                  domProps: { value: _vm.clientSecret },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.clientSecret = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("OAuth2 token endpoint uri:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tokenEndpointUri,
                      expression: "tokenEndpointUri",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.tokenEndpointUri },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.tokenEndpointUri = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("OAuth2 authorization endpoint uri:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.authorizationEndpointUri,
                      expression: "authorizationEndpointUri",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.authorizationEndpointUri },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.authorizationEndpointUri = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusInitial || _vm.statusInvalid,
                      expression: "statusInitial || statusInvalid",
                    },
                  ],
                  staticClass: "btn btn-primary btn-lg",
                  attrs: { type: "button" },
                  on: { click: _vm.handleConfigureOauth2CommandV1 },
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusInvoking,
                      expression: "statusInvoking",
                    },
                  ],
                  staticClass: "btn btn-primary btn-lg",
                  attrs: { type: "button", disabled: "" },
                },
                [_vm._v("Saving...")]
              ),
            ]
          ),
        ])
      : _vm.statusSucceed
      ? _c("div", { staticClass: "container" }, [
          _c("h4", [
            _vm._v("Congratulation! OAuth2 based SSO was configured."),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-lg",
              attrs: {
                href: `/#/admin/organizations/dashboard/${_vm.tid}`,
                role: "button",
              },
            },
            [_vm._v("Go to dashboard")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure SSO")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }